<template>
    <div :class="b()">
        <div class="table-responsive">
            <table class="table table-striped table-valign-middle">
                <thead>
                <tr>
                    <th>Пользователь</th>
                    <th>Название</th>
                    <th>Документ</th>
                    <th>Дата загрузки</th>
                    <th>Действие</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(document, index) in this.documents">
                    <td>
                        <a :href="$parent.userLink(document.userId)">{{ document.userName }}</a>
                    </td>
                    <td>{{ document.name }}</td>
                    <td>
                        <a :href="document.path " target="_blank">Посмотреть</a>
                    </td>
                    <td>
                        {{ document.createdAt }}
                    </td>
                    <td>

                        <!-- Открепить документ -->
                        <template v-if="action === 'detach'">
                            <button
                                    type="button"
                                    class="btn btn-danger"
                                    @click="detachDocument(document.id, document.type)"
                            >
                                Открепить
                            </button>
                        </template>

                        <!-- Прикрепить документ -->
                        <template v-if="action === 'attach'">
                            <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="attachDocument(document.id, document.type)"
                            >
                                Прикрепить
                            </button>
                        </template>

                        <!-- Удалить документ -->
                        <template v-if="action === 'delete'">
                            <button
                                    type="button"
                                    class="btn btn-danger"
                                    @click="deleteDocument(document.id)"
                            >
                                Удалить
                            </button>
                        </template>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    import CrmService from '../../services/CrmService';

    const COMPONENT_NAME = 'document-table';

    export default {
        name: COMPONENT_NAME,
        props: [
            'documents',
            'action',
            'buyingId',
            'buyingType',
        ],
        // mounted() {
        //
        // },
        methods: {

            // Прикрепить документ
            async attachDocument(documentId, documentType) {
                let response = await CrmService.attachDocumentToBuying(this.buyingId, this.buyingType, documentId, documentType);
                if (response) {
                    this.$message('Документ успешно прикреплен!');
                    this.$parent.getBuying();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Открепить документ
            async detachDocument(documentId, documentType) {

                if (!confirm('Вы уверены, что хотите открепить документ?')) return;

                let response = await CrmService.detachDocumentToBuying(documentId, documentType);
                if (response) {
                    this.$message('Документ успешно откреплен!');
                    this.$parent.getBuying();
                }else{
                    this.$message('Произошла ошибка');
                }
            },

            // Удалить документ
            async deleteDocument(documentId) {

                if (!confirm('Вы уверены, что хотите удалить документ?')) return;

                let response = await CrmService.deleteUserDocument(documentId);
                if (response) {
                    this.$message('Документ успешно удален!');
                    this.$parent.getUser();
                }else{
                    this.$message('Произошла ошибка');
                }
            }

        },
    }
</script>

<style lang="scss" scoped>
    .document-table {

    }
</style>